import { ConnectedUserPage } from './ConnectedUserPage';

export default ConnectedUserPage;
